import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAddApp$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAddApp extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-add-app", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M8.92105 2.78947C9.90208 2.78947 10.6974 3.58476 10.6974 4.56579V9.30263H15.4342C16.4152 9.30263 17.2105 10.0979 17.2105 11.0789V15.2237C17.2105 16.2047 16.4152 17 15.4342 17H4.77632C3.79528 17 3 16.2047 3 15.2237V4.56579C3 3.58476 3.79528 2.78947 4.77632 2.78947H8.92105ZM9.51316 10.4868H4.18421V15.2237C4.18421 15.5507 4.44931 15.8158 4.77632 15.8158H9.51237L9.51316 10.4868ZM15.4342 10.4868H10.6966V15.8158H15.4342C15.7612 15.8158 16.0263 15.5507 16.0263 15.2237V11.0789C16.0263 10.7519 15.7612 10.4868 15.4342 10.4868ZM8.92105 3.97368H4.77632C4.44931 3.97368 4.18421 4.23878 4.18421 4.56579V9.30263H9.51316V4.56579C9.51316 4.23878 9.24806 3.97368 8.92105 3.97368ZM14.7618 2.00541L14.8421 2C15.1419 2 15.3896 2.22275 15.4288 2.51176L15.4342 2.59211V4.56579H17.4079C17.7077 4.56579 17.9554 4.78854 17.9946 5.07755L18 5.15789C18 5.45765 17.7772 5.70539 17.4882 5.7446L17.4079 5.75H15.4342V7.72368C15.4342 8.02344 15.2115 8.27118 14.9225 8.31038L14.8421 8.31579C14.5423 8.31579 14.2946 8.09304 14.2554 7.80403L14.25 7.72368V5.75H12.2763C11.9766 5.75 11.7288 5.52725 11.6896 5.23824L11.6842 5.15789C11.6842 4.85813 11.907 4.6104 12.196 4.57119L12.2763 4.56579H14.25V2.59211C14.25 2.29235 14.4728 2.04461 14.7618 2.00541Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-add-app-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-add-app", "wpp-icon-add-app-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-add-app-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-add-app-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAddApp$1);
      }
      break;
  } });
}

const WppIconAddApp = WppIconAddApp$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAddApp, defineCustomElement };
